import L from 'leaflet';
import { useEffect } from 'react';
import { createElementObject, createOverlayComponent } from '@manifesto-tech/react-leaflet-core';
import { breakpoint } from '../../../../../vendorjs/breakpoint-helper.vendor';
L.CenterPopup = L.Popup.extend({
  options: {
    autoPan: false,
    keepInView: true
  },
  resizeEnd: setTimeout(function () {
    return false;
  }),
  initialize: function initialize(options, source) {
    L.setOptions(this, options);
    L.Popup.prototype.initialize.call(this, options, source);
  },
  getPercentage: function getPercentage(num, percentage) {
    return num * percentage / 100;
  },
  _initLayout: function _initLayout() {
    L.Popup.prototype._initLayout.call(this);
    this._handlers();
  },
  _updatePosition: function _updatePosition() {
    var _this = this;
    var map = this._map;

    // Unset content styles.
    this._contentNode.style = {};
    if (map) {
      var _this$_container;
      var size = breakpoint.isMobile ? 100 : 75;
      var mapPanePos = map._mapPane._leaflet_pos || {
        x: 0,
        y: 0
      };
      var mapWidth = map.getSize().x;
      var mapHeight = map.getSize().y;
      var contentHeight = this._contentNode.offsetHeight;
      var maxPopupHeight = this.getPercentage(mapHeight, size);
      var popupWidth = this.getPercentage(mapWidth, size);
      var popupHeight = contentHeight < maxPopupHeight ? contentHeight : maxPopupHeight;
      var paddingX = mapWidth - popupWidth;
      var paddingY = mapHeight - popupHeight;
      if ((_this$_container = this._container) !== null && _this$_container !== void 0 && _this$_container.style) {
        this._container.style.left = "".concat(paddingX / 2 - mapPanePos.x, "px");
        this._container.style.top = "".concat(paddingY / 2 - mapPanePos.y, "px");
        this._container.style.width = "".concat(popupWidth, "px");
        this._container.style.height = breakpoint.isMobile ? '' : "".concat(popupHeight, "px");
        this._container.style.transform = '';
      }

      // Recalculate popup width/height/position once images have loaded.
      var images = this._contentNode.querySelectorAll('img');
      images.forEach(function (img) {
        img.addEventListener('load', function () {
          _this._updatePosition();
        });
      });
    }
  },
  _handlers: function _handlers() {
    var _this2 = this;
    this._map.on('resize', function () {
      clearTimeout(_this2.resizeEnd);
      _this2.resizeEnd = setTimeout(function () {
        return _this2._updatePosition();
      }, 500);
    }, this);
    this._map.on('popupopen', this._updatePosition, this);
  }
});
L.centerPopup = function (options, source) {
  return new L.CenterPopup(options, source);
};
var CenterPopup = createOverlayComponent(function (props, context) {
  var popup = L.centerPopup(props, context.overlayContainer);
  return createElementObject(popup, context);
}, function (element, context, _ref, setOpen) {
  var position = _ref.position;
  var map = context.map,
    overlayContainer = context.overlayContainer;
  var instance = element.instance;
  useEffect(function () {
    function onPopupOpen(event) {
      if (event.popup === instance) {
        map.dragging.disable();
        map.smoothWheelZoom.disable();
        map.zoomControl.remove();
        map.attributionControl.remove();
        setOpen(true);
      }
    }
    function onPopupClose(event) {
      if (event.popup === instance) {
        map.dragging.enable();
        map.smoothWheelZoom.enable();
        map.zoomControl.addTo(map);
        map.attributionControl.addTo(map);
        setOpen(false);
      }
    }
    map.on({
      popupopen: onPopupOpen,
      popupclose: onPopupClose
    });
    if (!overlayContainer) {
      if (position) {
        instance.setLatLng(position);
      }
      instance.openOn(map);
    } else {
      overlayContainer.bindPopup(instance);
    }
    return function () {
      map.off({
        popupopen: onPopupOpen,
        popupclose: onPopupClose
      });
      overlayContainer && overlayContainer.unbindPopup();
      map.removeLayer(instance);
    };
  }, [context, element, position, setOpen]);
});
export default CenterPopup;